export const GHG_ESTIMATOR_CONCEPT_ID = 13613
export const IMPACT_STRATEGY_CONCEPT_ID = 93919
export const IMPACT_CARRY_CONCEPT_ID = 9876

const SPECIAL_IMPACT_CONCEPT_IDS = new Set([
  GHG_ESTIMATOR_CONCEPT_ID,
  IMPACT_STRATEGY_CONCEPT_ID,
  IMPACT_CARRY_CONCEPT_ID,
])

/** Any impact whose concept is not strategy / carry / GHG estimator. */
export const isCustomImpactConceptId = (
  conceptId: number | string | null | undefined,
): boolean => {
  if (conceptId == null || conceptId === '') return false
  const id = Number(conceptId)
  if (!Number.isFinite(id)) return false
  return !SPECIAL_IMPACT_CONCEPT_IDS.has(id)
}

export const impactIconForConceptId = (conceptId: number | string | null) => {
  const id = Number(conceptId)
  if (id === GHG_ESTIMATOR_CONCEPT_ID) return 'mdi-molecule-co2'
  if (id === IMPACT_CARRY_CONCEPT_ID) return 'mdi-finance'
  if (id === IMPACT_STRATEGY_CONCEPT_ID) return 'mdi-strategy'
  return 'mdi-bullseye-arrow'
}
